import React from 'react';
import baseStyles from './shield_icon.module.css';
import classNames from 'classnames';
import midnightShieldImage from './assets/dark.png';
import daylightShieldImage from './assets/light.png';
import { ColorCode as ColorCodeType } from 'services/accounts/types';
import { ColorCode } from 'services/accounts/protos/pangolin_dto_pb';
import { Theme, ThemeContext } from '../theme';

export enum ShieldSize {
  TINY,
  SMALL,
  MEDIUM,
  LARGE,
  EXTRA_LARGE,
}

export const containerColorStyles: Record<ColorCodeType, string> = {
  [ColorCode.BLUE]: baseStyles.lightBlueContainer,
  [ColorCode.GREEN]: baseStyles.greenContainer,
  [ColorCode.ORANGE]: baseStyles.orangeContainer,
  [ColorCode.RED]: baseStyles.redContainer,
  [ColorCode.VIOLET]: baseStyles.skyBlueContainer,
  [ColorCode.YELLOW]: baseStyles.yellowContainer,
};

const containerSizeStyles: Record<ShieldSize, string> = {
  [ShieldSize.TINY]: baseStyles.tinyContainer,
  [ShieldSize.SMALL]: baseStyles.smallContainer,
  [ShieldSize.MEDIUM]: baseStyles.mediumContainer,
  [ShieldSize.LARGE]: baseStyles.largeContainer,
  [ShieldSize.EXTRA_LARGE]: baseStyles.extraLargeContainer,
};

const shieldSizeStyles: Record<ShieldSize, string> = {
  [ShieldSize.TINY]: baseStyles.tinyIcon,
  [ShieldSize.SMALL]: baseStyles.smallIcon,
  [ShieldSize.MEDIUM]: baseStyles.mediumIcon,
  [ShieldSize.LARGE]: baseStyles.largeIcon,
  [ShieldSize.EXTRA_LARGE]: baseStyles.extraLargeIcon,
};

const shieldImages: Record<Theme, string> = {
  [Theme.DAYLIGHT]: daylightShieldImage,
  [Theme.MIDNIGHT]: midnightShieldImage,
};

const onlineStatusStyles = (onlineStatus?: boolean): string => {
  if (onlineStatus == null) {
    return '';
  } else if (onlineStatus) {
    return baseStyles.onlineStatusIcon;
  } else {
    return baseStyles.offlineStatusIcon;
  }
};

type ShieldIconProps = {
  colorCode: ColorCodeType;
  onlineStatus?: boolean;
  size: ShieldSize;
  className?: string;
};

export const ShieldIcon = ({ colorCode, size, onlineStatus, className }: ShieldIconProps) => {
  const theme = React.useContext(ThemeContext);

  return (
    <div className={classNames(containerColorStyles[colorCode], containerSizeStyles[size], className)}>
      {
        onlineStatus != null && <span className={onlineStatusStyles(onlineStatus)}></span>
      }
      <img
        src={shieldImages[theme]}
        className={shieldSizeStyles[size]}
        alt='shieldIcon'/>
    </div>
  );
};
